// generated by the plop

export class GetEquipmentList {
  static type = '[equipments] GetEquipmentList';

  constructor(public search: string, public onlyWithPreparedForUse = false) {
  }
}

export class GetEquipmentAutoCompleteList {
  static type = '[equipments] GetEquipmentAutoCompleteList';

  constructor(public search: string, public onlyWithPreparedForUse = false) {
  }
}
